import React, { Component } from "react";
export default class MapDataCenter extends Component {
  componentDidMount() {
    this.initMap();
    
  }

  initMap() {

    let options = {
        center: {lat: 47.433041, lng: 8.5552252},
	    zoom: 11,
	    styles: [{"featureType":"administrative.locality","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":7},{"lightness":19},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"visibility":"on"},{"saturation":"-3"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#748ca3"}]},{"featureType": "administrative","elementType": "geometry","stylers": [{ "visibility": "off" }]},{"featureType": "administrative.country","elementType": "geometry.stroke","stylers": [{"hue":"#ff0200"},{"saturation":4},{"lightness":10},{ "visibility": "on" }]},{"featureType": "administrative.province","elementType": "geometry.stroke","stylers": [{"hue":"#ff0200"},{"saturation":7},{"lightness":19},{ "visibility": "on" }]},{"featureType":"landscape","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":-100},{"lightness":100},{"visibility":"simplified"}]},{"featureType":"poi","elementType":"all","stylers":[{"hue":"#ff0200"},{"saturation":"23"},{"lightness":"20"},{"visibility":"off"}]},{"featureType":"poi.school","elementType":"geometry.fill","stylers":[{"color":"#ffdbda"},{"saturation":"0"},{"visibility":"on"}]},{"featureType":"road","elementType":"geometry","stylers":[{"hue":"#ff0200"},{"saturation":"100"},{"lightness":31},{"visibility":"simplified"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#f39247"},{"saturation":"0"}]},{"featureType":"road","elementType":"labels","stylers":[{"hue":"#008eff"},{"saturation":-93},{"lightness":31},{"visibility":"on"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#ffe5e5"},{"saturation":"0"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"hue":"#bbc0c4"},{"saturation":-93},{"lightness":-2},{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"hue":"#ff0200"},{"saturation":-90},{"lightness":-8},{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":10},{"lightness":69},{"visibility":"on"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#e9ebed"},{"saturation":-78},{"lightness":67},{"visibility":"simplified"}]}]

    };

   // init map
   let map = new window.google.maps.Map(
    document.getElementById("map"),
    options
  );
  
  // map marker
  var infowindow = new window.google.maps.InfoWindow();
  var service = new window.google.maps.places.PlacesService(map);
  var image = '/images/map-location.png';
  service.getDetails({
    placeId: 'ChIJeShNnacKkEcR2crCCsKhRAo'
  }, function(place, status) {
    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        const marker1 = new window.google.maps.Marker({
map: map,
draggable: false,
animation: window.google.maps.Animation.DROP,
position: place.geometry.location,
icon: image
});			
window.google.maps.event.addListener(marker1, 'click', function() {
        infowindow.setContent('<strong>Solar Communications GmbH.</strong> @ ' + place.name + '<br>' + place.formatted_address + '<br><a href="https://www.google.com/maps?cid=739894093571869401" target="_blank" rel="noopener noreferrer"><strong>Get directions</strong></a>');
        infowindow.open(map, marker1);
        });
    }
  });

}
  render() 
  {
    return (
    <div className={this.props.color === 'light' ? 'fullwidth light' : 'fullwidth dark'}>
        <div className="row">
            <div className="twelve columns">
                <div id="map" />
            </div>
        </div>
    </div>)
  }
}